import cn from 'classnames';
import * as Dfns from 'date-fns/fp';

import { MdArrowForward } from 'react-icons/md';

import './DateBox.scss';

const PRETTY_DATE_FORMAT = 'M/dd/yyyy';

interface DateBoxProps {
  start: string;
  end: string;
  dateFormat?: string;
  preformatted?: boolean;
  className?: string;
}

export const DateBox = ({
  start,
  end,
  dateFormat = PRETTY_DATE_FORMAT,
  preformatted = false,
  className
}: DateBoxProps) => {
  const prettyStart = preformatted ? start : Dfns.format(dateFormat)(Dfns.parseISO(start));
  const prettyEnd = preformatted ? end : Dfns.format(dateFormat)(Dfns.parseISO(end));
  return (
    <div className={cn('date-box', className)}>
      <div>{prettyStart}</div>
      <MdArrowForward className='arrow' />
      <div>{prettyEnd}</div>
    </div>
  );
};
